<header class="section-header">
    <h2
        class="m-0 min-w-0 truncate text-base font-semibold text-foreground"
        [id]="headingId()"
    >
        {{ label() }}
    </h2>
    @if (summary(); as summaryText) {
        <p>{{ summaryText }}</p>
    }
    <span class="section-header-action">
        <ng-content select="[qpxFilterSectionHeaderAction]" />
    </span>
</header>
<div class="section-content">
    <ng-content />
</div>
